/**
 * Địa chỉ 2 cấp sau sáp nhập (07/2025): phường/xã + tỉnh/thành phố — không còn quận/huyện.
 */

/** "Phường Xuân Hương - Đà Lạt" → "Phường Xuân Hương" */
export function cleanWardName(s) {
  return String(s ?? "").trim().replace(/\s+-\s+[^-]+$/, "").trim();
}

/** "Tỉnh Lâm Đồng" → "Lâm Đồng"; "Đà Lạt" (thành phố cũ) → "Lâm Đồng" */
export function cleanProvinceName(s) {
  const v = String(s ?? "").trim().replace(/^(tỉnh|thành phố|tp\.?)\s+/i, "").trim();
  if (/đà\s*lạt/i.test(v)) return "Lâm Đồng";
  return v;
}

const WARD_RX = /^(phường|xã|đặc khu)\s/i;

/** Lấy { ward, city } từ properties của Geoapify (dữ liệu OSM đặt phường ở nhiều khoá khác nhau). */
export function addressFromGeoapify(raw = {}) {
  const keys = ["suburb", "city", "town", "village", "municipality", "county", "district", "quarter"];
  const wardRaw = keys.map((k) => String(raw[k] || "").trim()).find((v) => WARD_RX.test(v)) || raw.suburb || "";
  const cityRaw = raw.state || raw.city || "";
  return { ward: cleanWardName(wardRaw), city: cleanProvinceName(cityRaw) };
}

/**
 * Ghép địa chỉ hiển thị: (phường, tỉnh) nếu có.
 */
export function formatLocationAddress(item = {}) {
  const tail = [item.ward, item.city]
    .map((s) => String(s ?? "").trim())
    .filter(Boolean);
  const tailStr = tail.join(", ");
  return tailStr;
}

/** Chuỗi dùng để search/filter phía client (lowercase). */
export function locationAddressSearchText(item = {}) {
  return [
    item.ward,
    item.city,
    formatLocationAddress(item),
  ]
    .map((s) => String(s ?? "").toLowerCase())
    .filter(Boolean)
    .join(" ");
}

/** Có ít nhất một phần địa chỉ để hiển thị khối địa chỉ. */
export function hasFormattedAddress(item = {}) {
  return Boolean(String(formatLocationAddress(item) || "").trim());
}
